import $ from 'jquery';
import TweenMax from 'gsap';

function MenuMobile(buttonSelector, targetSelector) {
  this.elems = {};
  this.elems.body = $('body');
  this.elems.btn = $(buttonSelector);
  this.elems.target = $(targetSelector);

  this.bindClicks();
}

MenuMobile.prototype.open = function() {
  TweenMax.set(this.elems.target, {
    display: 'block',
    opacity: 0,
    top: '-100px',
    left: '-100px',
  });

  this.elems.body.addClass('disable-scroll');

  TweenMax.to(this.elems.target, .5, {
    opacity: 1,
    top: 0,
    left: 0
  });
};

MenuMobile.prototype.close = function() {
  TweenMax.to(this.elems.target, .5, {
    display: 'none',
    opacity: 0,
    top: '-100px',
    left: '-100px',
  });

  this.elems.body.removeClass('disable-scroll');
};

MenuMobile.prototype.bindClicks = function() {
  // Abrir Menu
  this.elems.btn.click(e => {
    e.preventDefault();
    e.stopPropagation();
    this.open();
  });
  // Fechar Menu
  this.elems.target.find('.btn-mobile-close').click(e => {
    e.preventDefault();
    e.stopPropagation();
    this.close();
  });
  // Abrir Submenu
  let self = this;
  this.elems.target.find('.with-dropdown').each(function() {
    let menuElem = $(this);
    let dropdownElem = menuElem.find('> .main-menu-dropdown');
    
    menuElem.find('> .main-menu-link').click(e => {
      e.preventDefault();
      e.stopPropagation();

      if(menuElem.data('drop-openned') === '1') {
        menuElem.data('drop-openned', '0');
        menuElem.removeClass('active');
        dropdownElem.slideUp(150);
      } else {
        menuElem.data('drop-openned', '1');
        menuElem.addClass('active');
        dropdownElem.slideDown();
      }
    });
  });
};

export default MenuMobile;
